import { Field, Textarea } from '../../../gs-component-form';
import { FormBlockColumn } from '@xo-union/tk-component-form-grid';
import { Field as FormikField } from 'formik';
import React from 'react';

interface Props {
  namePrefix?: string;
}

export const OptionalForm: React.FC<Props> = ({ namePrefix = '' }) => {
  return (
    <>
      <FormBlockColumn>
        <FormikField data-testid="event_attire" name={`${namePrefix}attire`} label="Attire" component={Field} />
      </FormBlockColumn>
      <FormBlockColumn>
        <FormikField
          data-testid="event_description"
          name={`${namePrefix}notes`}
          label="Description"
          showAiButton={false}
          component={Textarea}
        />
      </FormBlockColumn>
    </>
  );
};
